import Head from "next/head"
import { useRouter } from "next/router"

const SITE_NAME = "Octopus Energy France"

interface CustomHeadProps {
    title?: string
    description?: string
    robots?: string
}

export default function CustomHead({
    title = "Fournisseur Électricité Verte",
    description = "Fournisseur d'électricité plus verte et moins chère\xa0: Octopus Energy arrive en France\xa0!",
    robots,
}: CustomHeadProps) {
    const router = useRouter()
    const pathSliceLength = Math.min.apply(Math, [
        router.asPath.includes("?") ? router.asPath.indexOf("?") : router.asPath.length,
        router.asPath.includes("#") ? router.asPath.indexOf("#") : router.asPath.length,
    ])
    const canonicalUrl =
        process.env.NEXT_PUBLIC_CONSUMER_BASE_URL + router.asPath.substring(0, pathSliceLength)

    const fullTitle = `${title} - ${SITE_NAME}`

    return (
        <Head>
            <meta
                name="viewport"
                content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=5"
            />
            <meta
                name="description"
                content={description}
            />
            <meta
                name="theme-color"
                content="#100030"
            />
            {robots && (
                <meta
                    name="robots"
                    content={robots}
                />
            )}

            {/* Open Graph */}
            <meta
                property="og:title"
                content={fullTitle}
            />
            <meta
                property="og:site_name"
                content={SITE_NAME}
            />
            <meta
                property="og:url"
                content={canonicalUrl}
            />
            <meta
                property="og:description"
                content={description}
            />
            <meta
                property="og:type"
                content="website"
            />
            <meta
                property="og:image"
                content="https://static.octopuscdn.com/favicons/apple-touch-icon-180x180.png"
            />

            {/* Twitter Cards */}
            <meta
                name="twitter:card"
                content="summary"
            />
            <meta
                name="twitter:site"
                content="@OctopusEnergy"
            />
            <meta
                name="twitter:creator"
                content="@OctopusEnergy"
            />
            <meta
                name="twitter:title"
                content={fullTitle}
            />
            <meta
                name="twitter:description"
                content={description}
            />
            <meta
                name="twitter:image"
                content="https://static.octopuscdn.com/favicons/apple-touch-icon-180x180.png"
            />

            <link
                rel="canonical"
                href={canonicalUrl}
            />

            {/* Tab */}
            <link
                rel="icon"
                href="https://static.octopuscdn.com/favicons/favicon.ico"
            />
            <title>{fullTitle}</title>
        </Head>
    )
}
